import { apiUrl } from "src/helpers/urls"

export const API_URL = `${apiUrl}/web`
export const getVersionedUrl = (version = 'v1') => `${apiUrl}/${version}/shared`
